module.exports = __webpack_public_path__ + "static/media/EMILIMA.a364ce85.png";